export function formatImageCaption(stringWithCaption: string) {
    if (!stringWithCaption) {
        return "";
    }

    const stringToReplace = /&nbsp;/gi;
    let formattedCaption = stringWithCaption;
    formattedCaption = formattedCaption.replace(stringToReplace, " ");

    return formattedCaption;
}
